module.exports = __webpack_public_path__ + "static/media/photo1.ef69cb95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/photo1.jpg
// module id = 366
// module chunks = 0